import React from 'react';

import { Box, ButtonGroup } from '@mui/material';
import { useWatch } from 'react-hook-form';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const SalesforceBulkWriterForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  const useBearerToken = useWatch({
    control: formControl,
    name: 'properties.useBearerToken',
    defaultValue: false,
  });

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="salesforceBulkWriterFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="salesforceBulkWriterFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="salesforceBulkWriterFormOnError"
        label="onError"
        name="onError"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        error={errors?.onError?.message}
      >
        <option value="">Select On Error</option>
        <option value="continue">Continue</option>
        <option value="stop">Stop</option>
      </FormField>

      <FormField
        controlId="salesforceBulkWriterFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="salesforceBulkWriterFormApiVersion"
        label="apiVersion"
        name="properties.apiVersion"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter API Version"
        error={errors?.properties?.apiVersion?.message}
      />
      <FormField
        controlId="salesforceBulkWriterFormUpsert"
        label="upsert"
        name="properties.upsert"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        error={errors?.properties?.upsert?.message}
      />
      <FormField
        controlId="salesforceBulkWriterFormExternalIdFieldName"
        label="externalIdFieldName"
        name="properties.externalIdFieldName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter External ID Field Name"
        error={errors?.properties?.externalIdFieldName?.message}
      />
      <FormField
        controlId="salesforceBulkWriterFormUseBearerToken"
        label="useBearerToken"
        name="properties.useBearerToken"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        error={errors?.properties?.useBearerToken?.message}
      />
      {!useBearerToken && (
        <>
          <FormField
            controlId="salesforceBulkWriterFormUsername"
            label="username"
            name="properties.username"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            placeholder="Enter Username"
            required
            error={errors?.properties?.username?.message}
          />
          <FormField
            controlId="salesforceBulkWriterFormPassword"
            label="password"
            name="properties.password"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            type="password"
            placeholder="Enter Password"
            required
            error={errors?.properties?.password?.message}
          />
        </>
      )}
      <FormField
        controlId="salesforceBulkWriterFormIsSandbox"
        label="isSandbox"
        name="properties.isSandbox"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        error={errors?.properties?.isSandbox?.message}
      />
      <FormField
        controlId="salesforceBulkWriterFormBatchSize"
        label="batchSize"
        name="properties.batchSize"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Batch Size"
        error={errors?.properties?.batchSize?.message}
      />
      <FormField
        controlId="salesforceBulkWriterFormSfObject"
        label="sfObject"
        name="properties.sfObject"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Salesforce Object"
        required
        error={errors?.properties?.sfObject?.message}
      />
      <FormField
        controlId="salesforceBulkWriterFormIsSerial"
        label="isSerial"
        name="properties.isSerial"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        error={errors?.properties?.isSerial?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default SalesforceBulkWriterForm;
